import { render, staticRenderFns } from "./home-advantages.vue?vue&type=template&id=8592bfc4&scoped=true&"
import script from "./home-advantages.vue?vue&type=script&lang=js&"
export * from "./home-advantages.vue?vue&type=script&lang=js&"
import style0 from "./home-advantages.vue?vue&type=style&index=0&id=8592bfc4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8592bfc4",
  null
  
)

export default component.exports